import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseHttpService, PageResponse } from 'src/app/auth/base-capacitor-http';
import { MatSnackBar } from '@angular/material/snack-bar';

export enum TrailerStatus {
  ALL = 'ALL',
  EMPTY = 'EMPTY',
  LOADED = 'LOADED',
  LOST = 'LOST',
  OUT_OF_SERVICE = 'OUT_OF_SERVICE',
  CHECKOUT = 'CHECKOUT'
}
export enum TrailerUpdateOption{
  DELETE = 'DELETE',
  CREATE = 'CREATE',
  CHECKOUT = 'CHECKOUT',
  UPDATE = 'UPDATE',
  LOST = 'LOST'
}
export class Trailer{
  id: string;
  trailer: string;
  status: string;
  carrier: string;
  location: string;
  instance: number;
  po: string;
}

export class TrailerSearchParams{
  page: number;
  size: number;
  search: string;
  type: TrailerSearchType;
}

export enum TrailerSearchType{
  TRAILER = 'TRAILER',
  STATUS = 'STATUS',
  ALL = 'ALL'
}


@Injectable({
  providedIn: 'root',
})
export class TrailerService extends BaseHttpService{

  private readonly baseURL: string = environment.server.mainURL;
  private endPointURL: string;

  constructor(client: HttpClient, snackbar: MatSnackBar) {
    super(client, snackbar);
  
  }

  getAllTrailerStatus(): string[] {
    return Object.values(TrailerStatus);
  }

  getCheckinTrailerStatus(): string[] {
    const excludedStatus: string[] = [TrailerStatus.LOST];
    return this.getAllTrailerStatus().filter(
      (status) => !excludedStatus.includes(status)
    );
  }


  /**
   * This is meant to add data in bulk to a collection whenever a user creates a new instance
   * for this reason a new collection is defined in method and the trailerCollection is not
   * used.
   * @param instanceId
   * @param trailers
   * @returns
   */
  async addBatchTrailers(trailers: Trailer[]): Promise<Trailer[]> {

    this.endPointURL = this.baseURL + 'trailer';
    return this.post<Trailer[]>(this.endPointURL, trailers);
  }


  async searchTrailers(params: TrailerSearchParams): Promise<PageResponse<Trailer>> {
    this.endPointURL = this.baseURL + 'trailer-search';
    return this.get<PageResponse<Trailer>>(this.endPointURL, params);
  }

  async updateTrailer(update: TrailerUpdateOption, trailer: Trailer): Promise<Trailer> {
    this.endPointURL = this.baseURL + 'trailer';
    let params = {
      update: update
    }
    let body = {
      trailer: JSON.stringify(trailer)
    }
   
    return this.put<Trailer>(this.endPointURL, body, params);
  }


}
